var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomCar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.154 12.53-1.684-5.6a2.976 2.976 0 0 0-2.86-2.13H9.35c-1.339 0-2.495.852-2.86 2.13l-1.684 5.6C3.75 12.996 3 14.05 3 15.268v5.985c0 .832.67 1.501 1.501 1.501v1.502c0 .831.67 1.5 1.502 1.5h1.5c.833 0 1.502-.669 1.502-1.5v-1.502h11.99v1.502c0 .831.67 1.5 1.501 1.5h1.501c.832 0 1.502-.669 1.502-1.5v-1.502c.832 0 1.501-.67 1.501-1.5v-5.986c-.04-1.237-.791-2.292-1.846-2.738zM9.35 7.782h11.26l1.338 4.504H7.991L9.35 7.782zm-.365 11.24c-.832 0-1.501-.67-1.501-1.502s.669-1.501 1.5-1.501c.833 0 1.502.67 1.502 1.501 0 .832-.67 1.501-1.501 1.501zm11.99 0c-.832 0-1.502-.67-1.502-1.502s.67-1.501 1.502-1.501c.831 0 1.5.67 1.5 1.501-.02.832-.689 1.501-1.5 1.501z",
    fill: "#1B7690",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomCar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-car.cca6da2af43059a0df659bec865ddeef.svg";